// Angular
import { Component, OnInit } from '@angular/core';
// Models
import { Tournament } from './../../models/tournament';
// Services
import { AngularFireDatabase } from 'angularfire2/database';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiService } from './../../services/api';
import * as lodash from 'lodash';
import { OAuthService } from './../../services/o-auth';
import { Club } from './../../models/club';
import { ActivatedRoute } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import * as moment from 'moment';
import { FormsService } from './../../services/forms';
import { Http, Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/Rx';
import { environment } from '../../../environments/environment'
@Component({
  templateUrl: './bank.component.html'
})
export class BankComponent implements OnInit {
  public form: FormGroup;
  public club: Club;
  public transactions: Array<any>
  public bank: any;
  public isEdit = true;
  private clientId: string
  public loading = true
  public redirectUrl = ""
  public isShowTransanctions = false;
  constructor(private fireDatabase: AngularFireDatabase, public formsService: FormsService,
    private apiService: ApiService, private oAuthService: OAuthService,
    private fireAuth: AngularFireAuth, private http: Http) {
    this.redirectUrl = "https://dashboard.stripe.com/oauth/authorize?response_type=code&client_id=" +
      environment.connectStripe + "&scope=read_write&redirect_uri=" + environment.stripeUrl
    this.clientId = this.getUrlParameter("code")
    console.log(this.clientId)
    if (this.clientId) {
      this.createAccount()
    } else {
      this.loading = false

    }
  }

  public getUrlParameter(sParam) {

    return decodeURIComponent(window.location.href.substring(1)).split('&').map((v) => {
      return v.split("=")
    }).filter((v) => {
      return (v[0] === sParam) ? true : false
    }).reduce((acc: any, curr: any) => {
      return curr[1];
    }, undefined);
  };

  private createAccount() {
    this.apiService.set("server-process/connect/" + this.oAuthService.getClub().cid + "/" + this.clientId, true)

  }

  ngOnInit() {

    this.initData();
    this.getTransactionDetail()
  }
  initData() {
    this.fireDatabase.object(`/users/${this.oAuthService.getClub().cid}/bank`)
      .subscribe(bank => {
        console.log(bank)
        if (bank.stripe_user_id) {
          this.loading = false
          this.isEdit = false;
        } else {
          this.isEdit = true;

        }

      })

  }
  getTransactionDetail() {
    // this.apiService.object(`/user-permissions/${}/`)
    console.log(this.oAuthService.getClub());
    this.fireDatabase.object(`/user-permissions/${this.oAuthService.getClub().uid}/${this.oAuthService.getClub().cid}`)
      .subscribe(result => {
        console.log(result);
        if (result.transactions.read) {
          this.isShowTransanctions = true
        } else {
          this.isShowTransanctions = false
        }
      })

    this.transactions = []
    this.apiService.list(`/club-transactions/${this.oAuthService.getClub().cid}`)
      .then(trans => {
        if (trans) {
          console.log(trans)
          this.transactions = trans
        }

      })

  }
  public edit() {
    this.isEdit = true;
  }


}
